import { gql } from "@apollo/client";

export const InstalledBaseNodeDetail = gql`
    query InstalledBaseNodeDetail($id: ID!) {
        installedBaseNode (id: $id){
            id
            key
            title
            isStarred
            keyPath
            pathNodes {
                id
                title
                nodeType {
                    id
                    key
                }
            }
            nodeType {
                id
                key
                name
            }
            parentNode {
                id
            }
            owner {
                id
                industryType
            }
            access {
                id
                read
                write
                delete
            }
            image {
                id
                file {
                    id
                    thumbnailLink (crop: fit, w: 118, h: 118)
                }
            }
            assetLocation {
                id
                asset {
                    id
                    product {
                        id
                        image {
                            id
                            thumbnailLink (crop: fit, w: 118, h: 118)
                        }
                    }
                }
            }
            system {
                id
                systemType
            }
        }
    }
`;
